module.exports = __webpack_public_path__ + "img/logo2.148409fd.png";